export default "__VITE_PUBLIC_ASSET__9da7c369__"